const TypesModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    FETCH_MAINPAGE(state, payload) {
      state.data = payload.reverse()
    },
    FETCH(state, payload) {
      state.data = payload
    },
    DELETE: (state, payload) => {
      var index = state.data.findIndex(data => data.typeid === payload)
      state.data.splice(index, 1)
    }
  },
  actions: {
    async fetchMainPage({ commit }) {
      try {
        const response = await axios.get(`/getTypesMainPage`)
        commit('FETCH_MAINPAGE', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async fetch({ commit }) {
      try {
        const response = await axios.get(`/getTypes`)
        commit('FETCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async delete({ commit }, payload) {
      try {
        await axios.delete(`/deleteTypes/${payload}`)
        commit('DELETE', payload)
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
      // return state.data.map(data => {
      //   return {
      //     name: data.name,
      //     url: data.urls[1] ? data.urls[1].url : data.urls[0].url,
      //     image: `${data.thumbnail.path}.${data.thumbnail.extension}`,
      //     description: data.description === '' ? 'No description listed for this character.' : data.description
      //   }
      // })
    },
    // getAllTypesNameList(state) {
    //   return state.data.map(item => item.nametha)
    // },
  }
}

export default TypesModule



// WEBPACK FOOTER //
// ./src/store/modules/types_module.js